module.exports = __webpack_public_path__ + "static/img/icon-menu3.657a944f.svg";